// import React, { Component } from 'react';
// import { Link } from 'react-router-dom'

// class Pagination extends Component {
//     render() {
//         return (
//             <ul>
//                 <li><Link to="#"><i className="far fa-angle-double-left" /></Link></li>
//                 <li className="active"><Link to="#">1</Link></li>
//                 <li><Link to="#">2</Link></li>
//                 <li><Link to="#">3</Link></li>
//                 <li><Link to="#">...</Link></li>
//                 <li><Link to="#">10</Link></li>
//                 <li><Link to="#"><i className="far fa-angle-double-right" /></Link></li>
//             </ul>
//         );
//     }
// }

// export default Pagination;

import React from 'react';
import { Link } from 'react-router-dom';

const Pagination = ({ currentPage, lastPage, onPageChange }) => {
    if (lastPage <= 1) return null;

    const pages = [];

    for (let i = 1; i <= lastPage; i++) {
        pages.push(i);
    }

    return (
        <ul>
            {/* PREVIOUS */}
            <li>
                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        if (currentPage > 1) onPageChange(currentPage - 1);
                    }}
                >
                    <i className="far fa-angle-double-left" />
                </Link>
            </li>

            {/* PAGE NUMBERS */}
            {pages.map(page => (
                <li
                    key={page}
                    className={currentPage === page ? 'active' : ''}
                >
                    <Link
                        to="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onPageChange(page);
                        }}
                    >
                        {page}
                    </Link>
                </li>
            ))}

            {/* NEXT */}
            <li>
                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        if (currentPage < lastPage) onPageChange(currentPage + 1);
                    }}
                >
                    <i className="far fa-angle-double-right" />
                </Link>
            </li>
        </ul>
    );
};

export default Pagination;

